/**
 * Generated runtime TestId mirror for frontend/src/pages/EscalationThresholds.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const EscalationThresholdsTestIds = {
  checkboxActive: "checkbox-active",
  editThresholdDialog: "edit-threshold-dialog",
  escalationThresholdsList: "escalation-thresholds-list",
  inputFinalReminderDays: "input-final-reminder-days",
  inputManagerDays: "input-manager-days",
  inputPlatformOwnerDays: "input-platform-owner-days",
  inputReminderDays: "input-reminder-days",
  selectManagerTarget: "select-manager-target",
  thActions: "th-actions",
  thActive: "th-active",
  thActiveSnapshots: "th-active-snapshots",
  thFinalReminderDays: "th-final-reminder-days",
  thManagerDays: "th-manager-days",
  thManagerTarget: "th-manager-target",
  thPlatformOwnerDays: "th-platform-owner-days",
  thReminderDays: "th-reminder-days",
  thRequestType: "th-request-type",
  thRiskLevel: "th-risk-level",
  validationError: "validation-error",
  btnEditThreshold: (threshold_id: string) => `btn-edit-threshold-${threshold_id}`,
  btnEditThresholdPrefix: () => "btn-edit-threshold-" as TestIdPrefix,
  thresholdRow: (threshold_id: string) => `threshold-row-${threshold_id}`,
  thresholdRowPrefix: () => "threshold-row-" as TestIdPrefix
} as const;
